import { render, staticRenderFns } from "./KokubanInput.vue?vue&type=template&id=c3ae17f6&scoped=true&"
import script from "./KokubanInput.vue?vue&type=script&lang=js&"
export * from "./KokubanInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ae17f6",
  null
  
)

export default component.exports